<div class="guest-preview">
  <div class="guest-preview__head">
    <span class="guest-preview__title">{{
      'SHARED.FOODBACK_STATEMENTS.MAIN.ADD_QUESTION_MODAL.PREVIEW.TITLE' | translate
    }}</span>

    <div class="guest-preview__lang">
      <button
        type="button"
        class="guest-preview__lang-trigger"
        [matMenuTriggerFor]="langMenu"
        data-testid="preview-language-trigger">
        <span
          class="flag-icon flag-icon-round"
          [class]="'flag-icon-' + previewLang()"
          aria-hidden="true"></span>
        <span class="guest-preview__lang-name">{{ previewLanguageName() }}</span>
        <mat-icon aria-hidden="true">expand_more</mat-icon>
      </button>
      <mat-menu #langMenu="matMenu">
        @for (language of activeLanguages(); track language.code) {
          <button
            type="button"
            mat-menu-item
            (click)="selectLanguage(language.code)"
            [attr.data-testid]="'preview-language-' + language.code">
            <span
              class="flag-icon flag-icon-round"
              [class]="'flag-icon-' + language.code"
              aria-hidden="true"></span>
            <span class="guest-preview__lang-name">{{ languageName(language) }}</span>
            @if (language.code === previewLang()) {
              <mat-icon class="guest-preview__lang-check" aria-hidden="true">check</mat-icon>
            }
          </button>
        }
      </mat-menu>
    </div>
  </div>

  <div class="guest-preview__phone">
    <div class="guest-preview__scale-intro">{{ stem() }}</div>

    <div class="guest-preview__body">
      @if (overallLabel(); as overall) {
        <div class="guest-preview__overall">
          <div class="guest-preview__q-label">{{ overall }}</div>
          <ul class="guest-preview__faces" aria-hidden="true">
            @for (face of faces; track face) {
              <li class="guest-preview__face">
                <img class="guest-preview__face-icon" [src]="'assets/svg/smileys/' + face + '.svg'" alt="" />
              </li>
            }
          </ul>
        </div>
      }

      <div class="guest-preview__questions">
        @for (row of rows(); track row.categoryUuid) {
          <div class="guest-preview__q" [class.guest-preview__q--new]="row.isNew">
            <div class="guest-preview__q-label">
              @if (row.isEmpty) {
                <span class="guest-preview__q-label-empty">{{
                  row.emptyKey | translate: { language: previewLanguageName() }
                }}</span>
              } @else {
                <span>{{ row.label }}</span>
              }
              @if (row.isNew) {
                <span class="guest-preview__new-badge">{{
                  'SHARED.FOODBACK_STATEMENTS.MAIN.ADD_QUESTION_MODAL.PREVIEW.NEW_BADGE' | translate
                }}</span>
              }
            </div>
            <ul class="guest-preview__faces" aria-hidden="true">
              @for (face of faces; track face) {
                <li class="guest-preview__face">
                  <img class="guest-preview__face-icon" [src]="'assets/svg/smileys/' + face + '.svg'" alt="" />
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>

  <p class="guest-preview__note">
    {{ 'SHARED.FOODBACK_STATEMENTS.MAIN.ADD_QUESTION_MODAL.PREVIEW.NOTE' | translate }}
  </p>
</div>
